// Cheesy way to get webpack working with legacy JS files

// External Libraries
//import $ from './_lib/jquery-3.3.1.js';
//window['$'] = require('./_lib/jquery-3.3.1.js');
import $ from 'jquery';
window.jQuery = $;
window.$ = $;


// Common
window['modal'] = require('./_common/modal.js');
window['nav'] = require('./_common/nav.js');
window['faqs'] = require('./_origin/faqs.js');
